const TEMP_STYLES = {
  hot: { bg: "#FDE8E6", color: "#B91C1C", border: "#F5B6B0", label: "Hot" },
  warm: { bg: "#FFF5E6", color: "#B45309", border: "#FCD9A3", label: "Warm" },
  cold: { bg: "#EEF0EF", color: "#374151", border: "#D3D8D6", label: "Cold" },
};

export function TempPill({ temperature, score }) {
  if (!temperature) return <span className="text-xs text-[#5C6B68]">—</span>;
  const s = TEMP_STYLES[temperature] || TEMP_STYLES.cold;
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-bold uppercase tracking-wider"
      style={{ background: s.bg, color: s.color, borderColor: s.border }}
      data-testid={`temp-pill-${temperature}`}
    >
      {s.label}{typeof score === "number" ? ` · ${score}` : ""}
    </span>
  );
}

export function StatusPill({ status }) {
  return (
    <span className={`status-${status} inline-flex rounded-full px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wider`}>
      {status}
    </span>
  );
}
